// Libs
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Row, Col } from '../../components/Elemental'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { QRCodeSVG } from 'qrcode.react';
import { decode } from 'js-base64';
// CSS
import './styles.scss'

// Components/Containers
import Button from '../../components/Button'
import Form from '../../components/Form'
import Input from '../../components/Input'
import LogoFull from '../../components/LogoFull'
import Warning from '../Warning'

//constants
import { getGreeting } from '../../constants/others'
import * as validate from '../../constants/validate'

// Actions
import { changeInvited, changeFirstTime } from '../Auth/actions'
import { createInviteChannel } from '../SpCasePage/actions'
import { signIn, verifySignIn, verifyDoubleAuth } from './actions'
import { change } from 'redux-form'

import withParams from '../../hoc/WithParams'
class SignInPage extends Component {

  UNSAFE_componentWillMount() {
    const { lastPathname, changeInvited, changeFirstTime, signIn, createInviteChannel, paramsEmail, paramsPassword, paramsType, channel, base64, history } = this.props

    if (base64) {
      let link = decode(base64)
      link = link.split('/')

      if (link[2] === 'forget-password') {
        return signIn({ email: link[0], password: link[1], type: link[2], lastPathname, history })
      }
      else {
        if (link[link.length - 1] === 'email' || link[link.length - 1] === 'whatsapp') {
          createInviteChannel(null, link[link.length - 1], link[0])
        }
        return signIn({ email: link[0], password: link[1], type: 'invite', lastPathname, history })
      }
    }

    if (paramsEmail && paramsPassword) {
      let type = paramsType ? paramsType : 'invite'

      if (type === 'invite' && channel) {
        createInviteChannel(null, channel, paramsEmail)
      }

      if (paramsType !== 'forget-password') {
        changeInvited(true)
        changeFirstTime(true)
      }
      return signIn({ email: paramsEmail, password: paramsPassword, type, lastPathname, history })
    }
  }

  componentDidMount() {
    const { change, paramsEmail, paramsPassword } = this.props

    if (paramsEmail && paramsPassword) {
      change('email', paramsEmail)
      change('password', paramsPassword)
    }
  }

  handleFormSubmit = (reduxFormData) => {
    const { lastPathname, verifySignIn, history } = this.props

    return verifySignIn({ ...reduxFormData, lastPathname, history })

  }

  handleDoubleAuthSubmit = (reduxFormData) => {
    const { lastPathname, verifyDoubleAuth, history, setupToken, isNewSetup } = this.props

    return verifyDoubleAuth({ ...reduxFormData, lastPathname, setupToken, isNewSetup, history })
  }

  render() {
    const { localLoading, formType, handleSubmit, qrcode } = this.props


    return (
      formType === 'login' ?
        <div className="sign-in-page">
          <LogoFull width={220} gutterBottom={10} />
          <span className="sign-in-page__greeting">{getGreeting()}! Ficamos felizes em tê-lo conosco.</span>
          <Form onSubmit={handleSubmit(this.handleFormSubmit)}>
            <Row>
              <Col>
                <Field
                  component={Input}
                  name="email"
                  type="email"
                  placeholder="Escreva aqui o seu email"
                  gutter={20}
                  validate={[validate.required, validate.email]} />
              </Col>
              <Col>
                <Field
                  component={Input}
                  name="password"
                  type="password"
                  placeholder="Escreva aqui a sua senha"
                  gutter={20}
                  validate={[validate.required]} />
              </Col>
            </Row>
            <Warning gutter={30} align="center" />
            <Button type="submit" localLoading={localLoading} gutter={15}>Entrar</Button>
          </Form>
          <div className="sign-in-page__actions">
            <h3 className="sign-in-page__redirect">
              <NavLink className="sign-in-page__link" to="/cadastro">Quero me cadastrar</NavLink>
            </h3>
            <h3 className="sign-in-page__redirect">
              <NavLink className="sign-in-page__link" to="/esqueci-minha-senha">Esqueci minha senha</NavLink>
            </h3>
          </div>
        </div>
        :
        <div className="sign-in-page">
          <LogoFull width={220} gutterBottom={10} />
          {qrcode ?
            <div className='sign-in-qrcode'>
              <h3>Para prosseguir, precisamos realizar uma verificação de segurança.</h3>
              <QRCodeSVG value={qrcode} />
              <h3>1 - Baixe o aplicativo Google Authenticator no seu celular;</h3>
              <h3>2 - Escaneie o QR code acima com seu celular;</h3>
              <h3>2 - Siga as instruções na tela;</h3>
              <h3>3 - Insira o código gerado pelo app no campo abaixo.</h3>
            </div>
            :
            <span className="sign-in-page__greeting">Por favor, digite o código de verificação do seu celular.</span>}
          <Form onSubmit={handleSubmit(this.handleDoubleAuthSubmit)}>
            <Row>
              <Col>
                <Field
                  component={Input}
                  name="code"
                  type="text"
                  placeholder="Código"
                  gutter={20}
                  validate={validate.required} />
              </Col>
            </Row>
            <Warning gutter={30} align="center" />
            <Button type="submit" localLoading={localLoading} gutter={15}>Entrar</Button>
          </Form>
        </div>
    )
  }
}

SignInPage = reduxForm({
  form: 'signIn',
})(SignInPage)

SignInPage = connect(
  (state, ownProps) => ({
    lastPathname: state.app.lastPathname,
    localLoading: state.app.localLoading,
    err: state.app.err,
    success: state.app.success,
    formType: state.auth.formType,
    qrcode: state.auth.qrcode,
    setupToken: state.auth.setupToken,
    isNewSetup: state.auth.isNewSetup,
    base64: ownProps.params.base64,
    paramsEmail: ownProps.params.email,
    paramsPassword: ownProps.params.password,
    paramsType: ownProps.params.type,
    channel: ownProps.params.channel,
    history: ownProps.history
  }),
  { changeInvited, changeFirstTime, signIn, change, createInviteChannel, verifySignIn, verifyDoubleAuth }
)(SignInPage)

export default withParams(SignInPage)
